import { UPDATE_DIALOG_CATEGORIES_CREATION_ERROR } from './index';

export const updateDialogCategoriesCreationErrorAction = (category_creation_error) => ({
    type: UPDATE_DIALOG_CATEGORIES_CREATION_ERROR,
    category_creation_error
});